import { CartAddEvent } from '@theme/events';

/**
 * PDP "You may also like". Cards are rendered server-side from the product's
 * curated complementary products (snippets/dgt-recommendations.liquid). This script
 * only handles quick-add clicks.
 */

function cartSectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component').forEach((c) => {
    if (c instanceof HTMLElement && c.dataset.sectionId) ids.add(c.dataset.sectionId);
  });
  return Array.from(ids).join(',');
}

class DgtRecommendations extends HTMLElement {
  #busy = false;

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-add]') : null;
    if (!btn || this.#busy || btn.hasAttribute('disabled')) return;
    event.preventDefault();
    this.#add(btn);
  };

  async #add(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    this.#busy = true;
    this.classList.add('is-busy');
    const original = btn.textContent;
    btn.textContent = 'Adding…';
    try {
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      body.append('sections', cartSectionIds());
      body.append('sections_url', window.location.pathname);
      const res = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const data = await res.json();
      if (data && data.status) {
        btn.textContent = 'Sold out';
        return;
      }
      this.dispatchEvent(
        new CartAddEvent({}, '', { source: 'dgt-recommendations', sections: data.sections, didError: false })
      );
      btn.textContent = 'Added ✓';
      setTimeout(() => (btn.textContent = original), 1500);
    } catch (e) {
      console.error('[dgt-recommendations] add failed', e);
      btn.textContent = original;
    } finally {
      this.#busy = false;
      this.classList.remove('is-busy');
    }
  }
}

if (!customElements.get('dgt-recommendations')) {
  customElements.define('dgt-recommendations', DgtRecommendations);
}
